import {firebaseConfigurations} from '@src/consts';

let firebase = null, 
    secondaryApp = null,
    database = null,
    messaging = null, 
    analytics = null ;

let firebasePromise,
    databasePromise,
    messagingPromise,
    analyticsPromise ;

const importFirebase = async () => { 
    const data = await import( 'firebase/app' ) ;
    firebase = data.default ;
    firebase.initializeApp( firebaseConfigurations.primary ); //rootApp
    secondaryApp = firebase.initializeApp( firebaseConfigurations.secondary, 'secondary' );
}
const importDatabase = async () =>{
    await import( 'firebase/database' );
    if( firebase ) database = firebase.database();
}

const importAnalytics = async () => {
    await import( 'firebase/analytics' );
    if( secondaryApp ) analytics = secondaryApp.analytics();
}

const importMessaging = async () =>{
    await import( 'firebase/messaging' );
    if( secondaryApp ) messaging = secondaryApp.messaging();
}


const getFirebasePromise = () => {
    if( firebasePromise ) return firebasePromise ;
    firebasePromise = importFirebase() ;
    return firebasePromise ;
}
const getDatabasePromise = () => {
    if( databasePromise ) return databasePromise ;
    databasePromise = importDatabase() ;
    return databasePromise ;
}
const getAnalyticsPromise = () => {
    if( analyticsPromise ) return analyticsPromise ;
    analyticsPromise = importAnalytics() ;
    return analyticsPromise ;
}
const getMessagingPromise = () => {
    if( messagingPromise ) return messagingPromise ;
    messagingPromise = importMessaging() ;
    return messagingPromise ;
}





const getDatabase = async () => {
    if( !firebase ) await getFirebasePromise();
    if( !database ) await getDatabasePromise();
    return database ;
}

const getAnalytics = async () => {
    if( !firebase ) await getFirebasePromise();
    if( !analytics ) await getAnalyticsPromise();
    return analytics ;
}

const getMessaging = async () => {
    if( !firebase ) await getFirebasePromise();
    if( !messaging ) await getMessagingPromise();
    return messaging ;
}


export {
    getDatabase,
    getMessaging,
    getAnalytics
};